import "../styles/base.scss";
import "../styles/loader.scss";
import "../styles/landing.scss";
import "../styles/coolLinks.scss";
import "../styles/skills.scss";
import "../styles/swiper.scss";
import "../styles/reviews.scss";
import "../styles/projects.scss";
import "../styles/faq.scss";
import "../styles/contact.scss";
